<template>
  <div>
    <a-modal
      v-model="showModal"
      :centered="true"
      :closable="false"
      width="587px"
      class="mobile-modal-fullscreen"
    >
      <div class="d-flex align-items-center">
        <font-awesome-icon
          size="2x"
          :icon="['fal', 'times']"
          class="show-in-mobile font-black mr-3 font20"
          @click="showModal = false"
        />
        <h4 class="fw700 font24 gray700 mb-0">{{ title }}?</h4>
        <button
          class="fw700 btn font-white p1224 font14 br6 show-in-mobile ml-auto"
          @click="save"
          :style="{ background: getPrimaryColor() }"
        >
          {{ saving ? "Submitting..." : Submit }}
        </button>
        <font-awesome-icon
          size="2x"
          :icon="['fal', 'times']"
          class="hide-in-mobile font-black ml-auto font20 cp"
          @click="showModal = false"
        />
      </div>
      <template slot="footer">
        <!-- <button key="cancel" @click="showModal = false" :style="{ background: '#fff', color: '#000', padding: '8px 40px', 'border-radius': '25px' }">
          Cancel
        </button> -->
        <button
          @click="showModal = false"
          class="bg-gray200 gray600 p1224 br6 fw700 font14 hide-in-mobile"
          :style="{ border: 'none' }"
        >
          Cancel
        </button>
        <!-- <a-button
          key="submit"
          type="primary"
          @click="save()"
          class="primary-button"
          :style="{ border: '1px solid ' + getPrimaryColor(), background: getPrimaryColor(), padding: '8px 40px', 'border-radius': '25px' }"
        >
          Submit
        </a-button> -->
        <button
          @click="save"
          :style="{ border: 'none', background: getPrimaryColor() }"
          class="br6 fw700 font14 font-white p1224 hide-in-mobile"
        >
          {{ saving ? "Submitting..." : "Submit" }}
        </button>
      </template>
      <!-- <h1 class="bg-error50 error500 m-1 text-center p-2 br8 m-4">WIP</h1> -->
      <a-textarea
        placeholder="Write your answer..."
        :rows="8"
        v-model="data"
        :maxlength="max"
        class="br8 p-3 mt-4"
        :style="{ border: '1px solid #CBD5E1' }"
      />
      <p class="text-right">
        <!-- <small class="font-light">{{ max - (data ? data.length : 0) }} Characters remaining</small> -->
        <small class="font-light">{{ data.length || 0 }}/{{ max }}</small>
      </p>
    </a-modal>
  </div>
</template>

<script>
export default {
  name: "EditBasicTextProfile",
  data() {
    return {
      showModal: false,
      key: null,
      data: "",
      title: null,
      max: 2000,
      titles: {
        // "WHEN IM HAVING A BAD DAY": "When I am having a bad day",
        what_inspires_me: "What inspires me",
        how_would_i_like_the_world_to_change:
          "How would i like the world to change",
        what_matters_to_me_the_most: "What matters to me the most",
        my_favourite_places_to_visit: "My favorite places to visit",
      },
      saving: false,
    };
  },
  methods: {
    show(key, data) {
      console.log("BasicTextModal show()");
      // console.log({ key })
      // console.log({ data })
      this.showModal = true;
      this.key = key;
      // let cardTitle = key.replace(/\_/g, " ").toUpperCase()
      // console.log({ cardTitle })
      // if (cardTitle === "WHEN IM HAVING A BAD DAY") {
      //   this.title = "When I am having a bad day"
      // } else {
      //   this.title = cardTitle
      // }
      // if (this.titles[key]) {
      // } else {
      //   this.title = cardTitle
      // }
      this.title = this.titles[key];
      this.data = data || "";
    },
    hide() {
      this.showModal = false;
    },
    save() {
      if (this.saving) {
        return;
      }
      this.saving = true;
      const payload = { [this.key]: this.data };
      const headers = { Authorization: `Bearer ${this.authUser.user.token}` };
      this.$http
        .put(
          `${process.env.BASE_API_URL}/${
            this.authUser.user.role === "patient"
              ? "normaluser"
              : this.authUser.user.role
          }/?user_id=${this.authUser.user.id}&circle_id=${
            this.currentCircle.id
          }`,
          payload,
          { headers }
        )
        .then((res) => {
          this.saving = false;
          this.hide();
          this.$emit("refresh");
        })
        .catch((err) => {
          this.saving = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.report-describe-textfield {
  width: 100%;
  min-width: 300px;
  max-width: 581px;
  height: 170px;
  resize: none;
  font-family: "Lato";
  font-weight: 400;
  font-size: 16px;
  line-height: 32px;
  color: #1e2945;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  padding: 12px 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/Modals/profile/BasicText.vue